export default {
  name: 'marking--updM',
  apiService: 'shoes',
  apiPath: '/admin/upd_m',
};